import { forwardRef } from 'react';
import type { JSX } from 'react';

import { useNow } from '@change-corgi/core/react/date';
import { useI18n } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

type Props = Readonly<{
	description: string;
	createdAt: string;
}>;

export const Milestone = forwardRef<HTMLElement, Props>(function Milestone(
	{ description, createdAt }: Props,
	ref,
): JSX.Element | null {
	const now = useNow();
	const { localizeRelativeTime } = useI18n();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<Flex
			variant="bordered"
			sx={{
				borderColor: isSunriseThemeEnabled ? 'sunrise.semantic.fill.inverse.weak' : 'neutral-grey100',
				backgroundColor: isSunriseThemeEnabled ? 'sunrise.semantic.fill.inverse.weak' : 'neutral-grey50',
			}}
			px={16}
			py={8}
			ref={ref}
		>
			<Text as="div" size="caption" sx={{ flex: 1 }}>
				{description}
			</Text>
			<Text as="div" size="caption" sx={{ whiteSpace: 'nowrap' }}>
				{localizeRelativeTime(now, createdAt)}
			</Text>
		</Flex>
	);
});
